export default {
    borderRadius: '5px',
    spacing: 8
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/layout.js